import React from 'react'

export default function Header({ title }) {
    return (
        <div className='mx-auto max-w-[1440px] bg-img bg-no-repeat py-5 px-4 font-semibold text-center text-white duration-200 hover:text-4xl text-3xl'>
            <h1>{title}</h1>
        </div>
    )
}